
module.exports = function getResource(label) {
    const resources = {
        color: 'Color',
        size: 'Size',
        edit: 'Edit'

    };

    return resources[label];
};
